import ITER_TOP from './iter/top.jpeg';
import ITER_CARD1 from './iter/card1.png';
import ITER_CARD2 from './iter/card2.png';
import ITER_CARD3 from './iter/card3.png';
import ITER_CARD4 from './iter/card4.jpeg';
import ITER_CARD5 from './iter/card5.png';
import ITER_PDF1 from './iter/ITER_GR5.8de32af9.pdf';
import ITER_PDF2 from './iter/ITER_GR6.1458db05.pdf';
import ITER_PDF3 from './iter/ITER_TCC1.f0808577.pdf';
import ITER_PDF4 from './iter/hvacita.pdf';
import ITER_PDF5 from './iter/vpssita.pdf';

export const iterIt = () => [
  {
    title: 'iter',
    internalTitle: 'Iter',
    locale: 'it',
    content: {
      boxes: [
        {
          key: 'slogan',
          value: '',
          richText:
            '<p>INTERNATIONAL THERMONUCLEAR EXPERIMENTAL REACTOR (ITER) PER LA FUSIONE NUCLEARE</p>',
          image: {
            small: {
              id: ITER_TOP,
            },
          },
          pdf: {
            filename: '',
          },
        },
        {
          key: 'text',
          value: "UN PROGETTO ALL'AVANGUARDIA",
          richText:
            '<p class="MsoNormal" style="text-align:justify"><strong>ITER (International\nThermonuclear Experimental Reactor)</strong> è il progetto internazionale che mira a\ncostruire un reattore sperimentale a fusione nel sito di Cadarache, in Francia,\ned è ad oggi uno dei progetti energetici più ambiziosi al mondo. La campagna\nsperimentale che verrà condotta presso ITER è fondamentale per far progredire\nla scienza della fusione e preparare la strada per le centrali a fusione di\ndomani.<o:p></o:p></p><p class="MsoNormal" style="text-align:justify">ITER sarà il primo dispositivo di\nfusione a produrre <span style="color:#ED7D31;mso-themecolor:accent2">“<u>energia\nnetta</u><sup>1</sup>”</span>, a mantenere la fusione per lunghi periodi di\ntempo e a testare le tecnologie integrate, i materiali e i regimi fisici necessari\nper la produzione commerciale di elettricità basata sulla fusione.<o:p></o:p></p><p class="MsoNormal" style="text-align:justify">I membri partecipanti al progetto\n- <strong>Cina, Unione europea, India, Giappone, Corea, Russia e Stati Uniti</strong> -\nsono ora impegnati in una collaborazione di 35 anni per costruire e utilizzare il\ndispositivo sperimentale ITER.<o:p></o:p></p><p class="MsoNormal" style="text-align:justify"><o:p>&nbsp;</o:p></p><p class="MsoNormal">\n\n\n\n\n\n\n\n</p> <p class="MsoNormal" style="text-align:justify"><br></p><p class="MsoNormal" style="text-align:justify"><i><span lang="EN-US" style="font-size:11.0pt;\nline-height:107%;font-family:&quot;Calibri&quot;,sans-serif;mso-ascii-theme-font:minor-latin;\nmso-fareast-font-family:Calibri;mso-fareast-theme-font:minor-latin;mso-hansi-theme-font:\nminor-latin;mso-bidi-font-family:&quot;Times New Roman&quot;;mso-bidi-theme-font:minor-bidi;\ncolor:#ED7D31;mso-themecolor:accent2;mso-ansi-language:EN-US;mso-fareast-language:\nEN-US;mso-bidi-language:AR-SA">1. Quando il plasma fuso genera più energia di quella che riceve per far\nfunzionare i sistemi di riscaldamento del plasma stesso.<o:p></o:p></span></i></p><p class="MsoNormal" style=""><span style="letter-spacing: 0.01em;"><br></span></p><p class="MsoNormal" style=""><strong><span style="letter-spacing: 0.01em;">Sito Web:&nbsp;</span><a href="https://www.iter.org/" style="text-align: justify; background-color: rgb(255, 255, 255);"><span lang="EN-US">ITER - the way to new energy</span></a></strong></p><p class="MsoNormal" style=""><strong><a id="photogallery" style="text-align: justify; background-color: rgb(255, 255, 255);"><span lang="EN-US">Apri photo gallery</span></a></strong></p><p class="MsoNormal" style=""><span style="letter-spacing: 0.01em;"><strong><br></strong></span></p><p class="MsoNormal" style="text-align:justify"><strong>FINCANTIERI SI</strong> partecipa\nattivamente al progetto <strong>ITER</strong>, installando insieme ad altre aziende:</p><ul><li style="text-align: justify;">impianti di ventilazione e condizionamento temporanei</li><li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">convertitori AC / DC per l\'alimentazione del sistema</span></li><li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">compensatori di potenza reattiva e filtri armonici</span></li><li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">sbarre in alluminio per la distribuzione dell\'energia</span></li><li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">resistenze per la dissipazione di aria calda</span></li><li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">tubi per alta pressione e sottovuoto spinto</span></li><li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">guide d\'onda innovative</span></li><li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">dispositivi diagnostici</span></li></ul><p class="MsoNormal" style="text-align:justify"><strong>FINCANTIERI SI</strong> ha inoltre\nfornito:</p><ul><li style="text-align: justify;">i gruppi aspiranti, completi di camini, per la dissipazione dell\'aria calda in caso di malfunzionamento</li><li style="text-align: justify;"><span style="font-family: Lato; letter-spacing: 0.14px; text-indent: -24px;">piattaforme speciali con protezione antincendio e decontaminazione al trizio</span><br></li></ul>',
          image: {
            small: {
              id: '',
            },
          },
          pdf: {
            filename: '',
          },
          noBrackets: true,
        },
        {
          key: 'card',
          value: 'GROUP 5',
          richText:
            '<p class="MsoNormal">Installazione di reti di commutazione, unità di scarica\nrapida complete di resistenze, bus-bars in alluminio raffreddate ad acqua e\naltri strumenti, cablaggi, canaline e supporti. Fornitura di gruppi aspiranti e\ncamini per la dissipazione dell\'aria calda.<o:p></o:p></p>',
          image: ITER_CARD1,
          pdf: ITER_PDF1,
        },
        {
          key: 'card',
          value: 'GROUP 6',
          richText:
            '<p class="MsoNormal">Installazione di convertitori AC/DC, compensatori di potenza\nreattiva e filtri armonici, integrazione del sistema di raffreddamento nel\ntrasformatore e trattamento olio.<o:p></o:p></p>',
          image: ITER_CARD2,
          pdf: ITER_PDF2,
        },
        {
          key: 'card',
          value: 'TCC1 Project',
          richText:
            "<p class=\"MsoNormal\">Installazione di tubazioni ad alta pressione, guide d'onda\ninnovative, dispositivi diagnostici, apparecchiature e tubazioni in sottovuoto spinto, sistemi di riscaldamento, cavi e supporti; fornitura di piattaforme\ninnovative antincendio con decontaminazione al tritio. Configurazione della\ncamera bianca per l'esecuzione del test dell'elio.<o:p></o:p></p>",
          image: ITER_CARD3,
          pdf: ITER_PDF3,
        },
        {
          key: 'card',
          value: 'TEMPORARY HVAC',
          richText:
            '<p class="MsoNormal">Progettazione, fornitura, installazione e test per i sistemi\ntemporanei di riscaldamento, ventilazione e condizionamento (HVAC) e relativi\nsistemi necessari per eseguire in sicurezza i lavori di assemblaggio della Fase\n1 Tokamak dell’Organizzazione ITER (IO).<o:p></o:p></p>',
          image: ITER_CARD4,
          pdf: ITER_PDF4,
        },
        {
          key: 'card',
          value: 'VPSS Captive Relief Pipe Wye Piece ',
          richText:
            '<p class="MsoNormal">Design e fornitura di un pezzo forgiato a Y per la linea di\nscarico.<o:p></o:p></p>',
          image: ITER_CARD5,
          pdf: ITER_PDF5,
        },
      ],
    },
    slug: 'iter',
    status: 'draft',
    id: '60b646fade796b74d91785a4',
    original: '60a297d48c18cd45de9451aa',
    createdBy: '5fd33ab1be673ff370b4957e',
    updatedBy: null,
    createdAt: '2021-06-01T14:40:58.459Z',
    updatedAt: '2021-06-01T14:40:58.470Z',
    expireAt: null,
    revision: 34,
    active: true,
    channelFeatured: null,
    roles: ['EDITOR', 'ADMIN', 'TECH'],
  },
];
